export const CareerState = 'careerState';
export const CopilotState = 'copilotState';
export const CurrentTrackingDetailsState = 'userTrackingReducer';
export const UserProfileState = 'userProfileState';
